// Helpers financeiros: formatação BR, mensagem de cobrança, link WhatsApp.

const BRL = new Intl.NumberFormat('pt-BR', {
  style: 'currency', currency: 'BRL', minimumFractionDigits: 2
})

export function formatBRL(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—'
  return BRL.format(Number(value))
}

// Status financeiro do acampante:
//  - 'sem-total': valorTotal não definido (não dá pra calcular)
//  - 'quitado': falta <= 0
//  - 'devendo': falta > 0
export function statusFinanceiro(acampante) {
  if (acampante?.valorTotal === null || acampante?.valorTotal === undefined) return 'sem-total'
  if ((acampante.falta || 0) <= 0.005) return 'quitado'
  return 'devendo'
}

// Normaliza um contato brasileiro pra E.164 ("5599999999999"). Aceita formatos
// variados: "(99) 99999-9999", "99 99999-9999", "+55 99 99999-9999", etc.
// Retorna null se não conseguir reconhecer DDD + número (10 ou 11 dígitos).
export function normalizaTelefoneBR(raw) {
  if (!raw) return null
  let digits = String(raw).replace(/\D/g, '')
  if (digits.length < 10) return null
  // Se começa com 55 e tem 12-13 dígitos, já tem código país.
  if (digits.length === 12 || digits.length === 13) {
    if (digits.startsWith('55')) return digits
    return null
  }
  // 10 dígitos = DDD + fixo 8 dígitos; 11 dígitos = DDD + celular 9 dígitos.
  if (digits.length === 10 || digits.length === 11) return `55${digits}`
  return null
}

// Template padrão de mensagem de cobrança. Substituições simples.
export function buildMensagemCobranca(acampante) {
  const nome = (acampante?.name || '').split(' ')[0] || 'aí'
  const falta = formatBRL(acampante?.falta)
  return (
    `Oi ${nome}! Tudo bem? Passando aqui pra lembrar do acampamento — ` +
    `tá faltando ${falta} pra quitar. Qualquer dúvida me chama. 🙏`
  )
}

export function buildWhatsAppLink(acampante) {
  const phone = normalizaTelefoneBR(acampante?.contato)
  if (!phone) return null
  const msg = encodeURIComponent(buildMensagemCobranca(acampante))
  return `https://wa.me/${phone}?text=${msg}`
}
